import React, { useState } from "react";

const styles = {
  page: {
    background: "#000",
    color: "#fff",
    minHeight: "100vh",
    padding: "48px 24px",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'Helvetica Neue', sans-serif",
  },
  container: {
    maxWidth: "720px",
    margin: "0 auto",
  },
  header: {
    textAlign: "center",
    marginBottom: "48px",
  },
  badge: {
    display: "inline-block",
    background: "rgba(168,85,247,0.15)",
    border: "1px solid rgba(168,85,247,0.4)",
    color: "#c084fc",
    fontSize: "11px",
    fontWeight: "600",
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    padding: "6px 14px",
    borderRadius: "100px",
    marginBottom: "20px",
  },
  h1: {
    fontSize: "36px",
    fontWeight: "700",
    letterSpacing: "-0.03em",
    color: "#fff",
    margin: "0 0 10px",
  },
  subtitle: {
    fontSize: "15px",
    color: "rgba(255,255,255,0.45)",
    fontWeight: "400",
    letterSpacing: "-0.01em",
    margin: "0 0 20px",
  },
  freeBox: {
    display: "inline-block",
    background: "rgba(34,197,94,0.12)",
    border: "1.5px solid rgba(34,197,94,0.4)",
    borderRadius: "14px",
    padding: "14px 24px",
    marginBottom: "20px",
  },
  freeBoxTitle: {
    fontSize: "15px",
    fontWeight: "700",
    color: "#4ade80",
    margin: "0 0 4px",
    letterSpacing: "-0.01em",
  },
  freeBoxSub: {
    fontSize: "13px",
    color: "rgba(255,255,255,0.5)",
    margin: 0,
    lineHeight: "1.5",
  },
  limitBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    margin: "0 0 8px",
  },
  limitDot: (filled) => ({
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    background: filled ? "#a855f7" : "rgba(255,255,255,0.15)",
    transition: "background 0.2s",
  }),
  limitText: (count) => ({
    fontSize: "13px",
    fontWeight: "600",
    color: count >= 3 ? "#f87171" : count > 0 ? "#c084fc" : "rgba(255,255,255,0.4)",
    letterSpacing: "-0.01em",
    textAlign: "center",
    marginBottom: "4px",
  }),
  introText: {
    fontSize: "14px",
    color: "rgba(255,255,255,0.55)",
    lineHeight: "1.7",
    maxWidth: "520px",
    margin: "0 auto",
  },
  divider: {
    border: "none",
    borderTop: "1px solid rgba(255,255,255,0.08)",
    margin: "36px 0",
  },
  sectionTitle: {
    fontSize: "11px",
    fontWeight: "600",
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: "#a855f7",
    marginBottom: "20px",
  },
  featureBlock: (selected, locked) => ({
    marginBottom: "32px",
    background: selected
      ? "rgba(168,85,247,0.06)"
      : locked
      ? "rgba(255,255,255,0.01)"
      : "rgba(255,255,255,0.03)",
    border: selected
      ? "1px solid rgba(168,85,247,0.3)"
      : "1px solid rgba(255,255,255,0.08)",
    borderRadius: "16px",
    padding: "24px",
    opacity: locked ? 0.45 : 1,
    transition: "all 0.2s ease",
  }),
  featureHeader: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    marginBottom: "12px",
  },
  featureNumber: {
    color: "#a855f7",
    fontSize: "13px",
    fontWeight: "700",
    flexShrink: 0,
    marginTop: "2px",
  },
  featureTitle: {
    fontSize: "17px",
    fontWeight: "600",
    letterSpacing: "-0.02em",
    color: "#fff",
    margin: "0 0 6px",
    lineHeight: "1.3",
  },
  featureDesc: {
    fontSize: "13px",
    color: "rgba(255,255,255,0.45)",
    lineHeight: "1.6",
    margin: "0 0 16px",
  },
  featureBullets: {
    margin: "0 0 16px 0",
    padding: "0",
    listStyle: "none",
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
  },
  bulletTag: {
    fontSize: "12px",
    color: "rgba(255,255,255,0.5)",
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "6px",
    padding: "3px 10px",
    letterSpacing: "-0.01em",
  },
  platformRow: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
  },
  platformBtn: (active) => ({
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 16px",
    borderRadius: "10px",
    border: active ? "1.5px solid #a855f7" : "1px solid rgba(255,255,255,0.1)",
    background: active ? "rgba(168,85,247,0.12)" : "rgba(255,255,255,0.03)",
    color: active ? "#e9d5ff" : "rgba(255,255,255,0.5)",
    fontSize: "13px",
    fontWeight: active ? "600" : "400",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', sans-serif",
    cursor: "pointer",
    letterSpacing: "-0.01em",
    transition: "all 0.15s ease",
  }),
  checkDot: (active) => ({
    width: "7px",
    height: "7px",
    borderRadius: "50%",
    background: active ? "#a855f7" : "rgba(255,255,255,0.2)",
    flexShrink: 0,
    transition: "background 0.15s",
  }),
  addonsGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "8px",
  },
  addonBtn: (active) => ({
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "12px 14px",
    borderRadius: "12px",
    border: active ? "1.5px solid #22c55e" : "1px solid rgba(255,255,255,0.08)",
    background: active ? "rgba(34,197,94,0.1)" : "rgba(255,255,255,0.03)",
    color: active ? "#86efac" : "rgba(255,255,255,0.55)",
    fontSize: "13px",
    fontWeight: active ? "600" : "400",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', sans-serif",
    cursor: "pointer",
    textAlign: "left",
    letterSpacing: "-0.01em",
    transition: "all 0.15s ease",
  }),
  addonDot: (active) => ({
    width: "7px",
    height: "7px",
    borderRadius: "50%",
    background: active ? "#22c55e" : "rgba(255,255,255,0.2)",
    flexShrink: 0,
  }),
  appTypeRow: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  appTypeBtn: (active) => ({
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "14px 16px",
    borderRadius: "12px",
    border: active ? "1.5px solid #eab308" : "1px solid rgba(255,255,255,0.08)",
    background: active ? "rgba(234,179,8,0.1)" : "rgba(255,255,255,0.03)",
    color: active ? "#fde68a" : "rgba(255,255,255,0.6)",
    fontSize: "14px",
    fontWeight: active ? "600" : "400",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', sans-serif",
    cursor: "pointer",
    textAlign: "left",
    letterSpacing: "-0.01em",
    transition: "all 0.15s ease",
  }),
  appTypeDot: (active) => ({
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    background: active ? "#eab308" : "rgba(255,255,255,0.2)",
    flexShrink: 0,
  }),
  inputGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
    marginBottom: "12px",
  },
  inputFull: {
    marginBottom: "12px",
  },
  input: {
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "12px",
    padding: "14px 16px",
    color: "#fff",
    fontSize: "15px",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', sans-serif",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
    transition: "border-color 0.2s",
  },
  textarea: {
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "12px",
    padding: "14px 16px",
    color: "#fff",
    fontSize: "14px",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', sans-serif",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
    resize: "vertical",
    minHeight: "100px",
    lineHeight: "1.6",
  },
  submitBtn: (loading) => ({
    width: "100%",
    padding: "16px",
    background: loading ? "rgba(168,85,247,0.5)" : "#a855f7",
    border: "none",
    borderRadius: "14px",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "600",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', sans-serif",
    cursor: loading ? "not-allowed" : "pointer",
    letterSpacing: "-0.01em",
    marginTop: "8px",
    transition: "opacity 0.2s, transform 0.1s",
  }),
  summaryCard: {
    marginTop: "36px",
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "20px",
    padding: "32px",
  },
  summaryHeader: {
    fontSize: "13px",
    fontWeight: "600",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    color: "#fff",
    marginBottom: "20px",
  },
  summaryBusinessName: {
    fontSize: "22px",
    fontWeight: "700",
    letterSpacing: "-0.03em",
    color: "#fff",
    margin: "0 0 4px",
  },
  summaryContact: {
    fontSize: "14px",
    color: "rgba(255,255,255,0.6)",
    margin: "0 0 28px",
  },
  summarySection: {
    marginBottom: "24px",
  },
  summarySectionTitle: {
    fontSize: "11px",
    fontWeight: "600",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    color: "#a855f7",
    marginBottom: "12px",
  },
  featureTag: (platform) => {
    const colors = {
      web: { bg: "rgba(59,130,246,0.12)", border: "rgba(59,130,246,0.35)", text: "#93c5fd" },
      mobile: { bg: "rgba(34,197,94,0.1)", border: "rgba(34,197,94,0.3)", text: "#86efac" },
      both: { bg: "rgba(168,85,247,0.12)", border: "rgba(168,85,247,0.35)", text: "#c084fc" },
    };
    const c = colors[platform] || colors.both;
    return {
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      padding: "4px 10px",
      borderRadius: "6px",
      background: c.bg,
      border: `1px solid ${c.border}`,
      color: c.text,
      fontSize: "11px",
      fontWeight: "600",
      letterSpacing: "0.05em",
      textTransform: "uppercase",
    };
  },
  selectedFeatureRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 0",
    borderBottom: "1px solid rgba(255,255,255,0.06)",
    gap: "12px",
  },
  selectedFeatureName: {
    fontSize: "13px",
    color: "rgba(255,255,255,0.85)",
    fontWeight: "500",
  },
  addonTagRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
  },
  addonTag: {
    fontSize: "12px",
    color: "#86efac",
    background: "rgba(34,197,94,0.1)",
    border: "1px solid rgba(34,197,94,0.25)",
    borderRadius: "6px",
    padding: "4px 10px",
  },
  summaryRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px 0",
    borderBottom: "1px solid rgba(255,255,255,0.06)",
    gap: "16px",
  },
  summaryKey: {
    fontSize: "13px",
    color: "rgba(255,255,255,0.5)",
    fontWeight: "500",
    flexShrink: 0,
  },
  summaryVal: {
    fontSize: "13px",
    color: "#fff",
    fontWeight: "500",
    textAlign: "right",
  },
  thankYouBox: {
    marginTop: "24px",
    padding: "20px",
    background: "rgba(168,85,247,0.1)",
    border: "1.5px solid rgba(168,85,247,0.35)",
    borderRadius: "14px",
    textAlign: "center",
  },
  thankYouText: {
    fontSize: "14px",
    color: "rgba(255,255,255,0.7)",
    lineHeight: "1.6",
    margin: 0,
  },
};

const features = [
  {
    key: "f1",
    title: "Customer Booking System",
    desc: "Allows customers to book junk removal online, choose date and time, upload photos, add pickup address, and receive confirmation notifications.",
    bullets: ["Online Booking", "Date & Time Picker", "Photo Uploads", "Address Input", "Notifications"],
  },
  {
    key: "f2",
    title: "Instant Quote / Estimate System",
    desc: "Generates automatic price estimates based on item type, truck space, photos, weight, or volume.",
    bullets: ["Fast Quotes", "Price Calculator", "PDF Estimates", "SMS/Email Quotes"],
  },
  {
    key: "f3",
    title: "Junk Removal CRM",
    desc: "Manage all customers and jobs in one place with full history, notes, follow-ups, and invoice tracking.",
    bullets: ["Customer Database", "Job History", "Notes & Follow-ups", "Invoice Tracking"],
  },
  {
    key: "f4",
    title: "Dispatch & Driver Management",
    desc: "Manage drivers and trucks efficiently with job assignment, route management, and real-time updates.",
    bullets: ["Assign Jobs", "Track Drivers", "Route Management", "GPS Tracking", "Job Status"],
  },
  {
    key: "f5",
    title: "Route Optimization System",
    desc: "Automatically creates the best driving routes to save fuel, reduce travel time, and increase daily jobs.",
    bullets: ["Save Fuel", "Reduce Travel Time", "Increase Daily Jobs"],
  },
  {
    key: "f6",
    title: "Invoice & Payment System",
    desc: "Create and manage payments with digital invoices, online payments, receipts, and balance tracking.",
    bullets: ["Digital Invoices", "Online Payments", "Receipts", "Balance Tracking"],
  },
  {
    key: "f7",
    title: "Employee Time Tracking System",
    desc: "Track worker hours and attendance with GPS, payroll reports, and shift management.",
    bullets: ["Clock In/Out", "GPS Attendance", "Payroll Reports", "Shift Tracking"],
  },
  {
    key: "f8",
    title: "Review & Feedback Automation",
    desc: "Automatically request customer reviews after each job via SMS with Google review links.",
    bullets: ["SMS Review Requests", "Google Review Links", "Feedback Tracking"],
  },
  {
    key: "f9",
    title: "Dumpster Rental Management",
    desc: "Manage dumpster rental operations including scheduling, delivery tracking, and billing.",
    bullets: ["Rental Scheduling", "Delivery Tracking", "Pickup Reminders", "Billing"],
  },
  {
    key: "f10",
    title: "Recycling & Disposal Tracking",
    desc: "Track disposal and recycling information with reports, scrap value tracking, and landfill management.",
    bullets: ["Recycling Reports", "Scrap Value Tracking", "Disposal Records", "Landfill Management"],
  },
  {
    key: "f11",
    title: "Admin Dashboard",
    desc: "Business owner dashboard with full analytics including revenue, employee performance, and customer stats.",
    bullets: ["Revenue Reports", "Daily Jobs", "Employee Performance", "Customer Statistics"],
  },
];

const platformOptions = [
  { val: "web", label: "Web App" },
  { val: "mobile", label: "Mobile App" },
  { val: "both", label: "Both Web + Mobile" },
];

const addonOptions = [
  "Website Design",
  "Logo Design",
  "SEO Services",
  "Online Payment Integration",
  "SMS Notifications",
  "AI Features",
  "GPS Tracking",
  "Multi-Language Support",
];

const appTypeOptions = [
  { val: "web", label: "Web App Only" },
  { val: "mobile", label: "Mobile App Only" },
  { val: "both", label: "Both Web + Mobile App" },
];

const MAX_SELECTIONS = 3;

export default function SoftwareSelection() {
  const [selections, setSelections] = useState(
    Object.fromEntries(features.map(f => [f.key, ""]))
  );
  const [addons, setAddons] = useState([]);
  const [appType, setAppType] = useState("");
  const [business, setBusiness] = useState({
    businessName: "",
    contactName: "",
    phone: "",
    email: "",
    problems: "",
    notes: "",
  });
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);

  const selectedCount = Object.values(selections).filter(v => v !== "").length;

  const selectPlatform = (featureKey, val) => {
    const isSelected = selections[featureKey] !== "";
    const isSameVal = selections[featureKey] === val;

    if (isSameVal) {
      setSelections(prev => ({ ...prev, [featureKey]: "" }));
      return;
    }

    if (!isSelected && selectedCount >= MAX_SELECTIONS) {
      return;
    }

    setSelections(prev => ({ ...prev, [featureKey]: val }));
  };

  const toggleAddon = (addon) => {
    setAddons(prev =>
      prev.includes(addon) ? prev.filter(a => a !== addon) : [...prev, addon]
    );
  };

  const handleBusiness = (field, val) => {
    setBusiness(prev => ({ ...prev, [field]: val }));
  };

  const generateSummary = async () => {
    const selected = features.filter(f => selections[f.key]);

    if (selected.length === 0) {
      alert("Please select at least 1 software feature before submitting.");
      return;
    }

    const payload = { selections, addons, appType, business };

    setLoading(true);
    try {
      const res = await fetch("https://reflex-backend.alfaoir1.workers.dev/software-form", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.success) {
        setSummary({ selected, selections, addons, appType, business });
      } else {
        alert("Submission failed: " + data.error);
      }
    } catch (err) {
      alert("Network error: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const platformLabel = (val) => {
    if (val === "web") return "Web App";
    if (val === "mobile") return "Mobile App";
    if (val === "both") return "Web + Mobile";
    return "";
  };

  const limitMessage = () => {
    if (selectedCount === 0) return "Select up to 3 features below";
    if (selectedCount === MAX_SELECTIONS) return "Maximum 3 selected — deselect one to change";
    return `${selectedCount} of 3 selected`;
  };

  return (
    <div style={styles.page}>
      <div style={styles.container}>

        {/* Header */}
        <div style={styles.header}>
          <div style={styles.badge}>Custom Software</div>
          <h1 style={styles.h1}>Junk Removal Software</h1>
          <p style={styles.subtitle}>Request Form · Feature Selection</p>

          <div style={styles.freeBox}>
            <p style={styles.freeBoxTitle}>🎁 First Month 100% Free — Trial Version</p>
            <p style={styles.freeBoxSub}>
              Select up to <strong style={{ color: "#fff" }}>3 software features</strong> you need most.<br />
              We will build and deliver them for your junk removal business completely free for the first month so you can test how it works. After one month, we will share the pricing with you.
            </p>
          </div>

          <div style={{ marginBottom: "8px" }}>
            <p style={styles.limitText(selectedCount)}>{limitMessage()}</p>
            <div style={styles.limitBar}>
              {[0, 1, 2].map(i => (
                <span key={i} style={styles.limitDot(i < selectedCount)} />
              ))}
            </div>
          </div>

          <p style={styles.introText}>
            Choose 1, 2, or a maximum of 3 features. For each one, select whether you need a Web App, Mobile App, or Both.
          </p>
        </div>

        <hr style={styles.divider} />

        <div style={styles.sectionTitle}>Software Features — Pick Up To 3</div>

        {features.map((f, i) => {
          const isSelected = selections[f.key] !== "";
          const isLocked = !isSelected && selectedCount >= MAX_SELECTIONS;

          return (
            <div key={f.key} style={styles.featureBlock(isSelected, isLocked)}>
              <div style={styles.featureHeader}>
                <span style={styles.featureNumber}>{i + 1}.</span>
                <div style={{ flex: 1 }}>
                  <div style={styles.featureTitle}>{f.title}</div>
                  <p style={styles.featureDesc}>{f.desc}</p>
                  <ul style={styles.featureBullets}>
                    {f.bullets.map(b => (
                      <li key={b} style={styles.bulletTag}>{b}</li>
                    ))}
                  </ul>
                  <div style={styles.platformRow}>
                    {platformOptions.map(opt => (
                      <button
                        key={opt.val}
                        onClick={() => selectPlatform(f.key, opt.val)}
                        style={styles.platformBtn(selections[f.key] === opt.val)}
                        disabled={isLocked}
                      >
                        <span style={styles.checkDot(selections[f.key] === opt.val)} />
                        {opt.label}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        <hr style={styles.divider} />

        <div style={styles.sectionTitle}>Additional Requirements</div>
        <div style={{ marginBottom: "32px", background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: "16px", padding: "24px" }}>
          <div style={styles.addonsGrid}>
            {addonOptions.map(addon => (
              <button
                key={addon}
                onClick={() => toggleAddon(addon)}
                style={styles.addonBtn(addons.includes(addon))}
              >
                <span style={styles.addonDot(addons.includes(addon))} />
                {addon}
              </button>
            ))}
          </div>
        </div>

        <hr style={styles.divider} />

        <div style={styles.sectionTitle}>Preferred App Type</div>
        <div style={{ marginBottom: "32px", background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: "16px", padding: "24px" }}>
          <div style={styles.appTypeRow}>
            {appTypeOptions.map(opt => (
              <button
                key={opt.val}
                onClick={() => setAppType(appType === opt.val ? "" : opt.val)}
                style={styles.appTypeBtn(appType === opt.val)}
              >
                <span style={styles.appTypeDot(appType === opt.val)} />
                {opt.label}
              </button>
            ))}
          </div>
        </div>

        <hr style={styles.divider} />

        <div style={styles.sectionTitle}>Business Information</div>
        <div style={{ marginBottom: "32px", background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: "16px", padding: "24px" }}>
          <div style={styles.inputGrid}>
            <input
              placeholder="Business Name"
              style={styles.input}
              value={business.businessName}
              onChange={e => handleBusiness("businessName", e.target.value)}
            />
            <input
              placeholder="Contact Name"
              style={styles.input}
              value={business.contactName}
              onChange={e => handleBusiness("contactName", e.target.value)}
            />
            <input
              placeholder="Phone Number"
              style={styles.input}
              value={business.phone}
              onChange={e => handleBusiness("phone", e.target.value)}
            />
            <input
              placeholder="Email Address"
              style={styles.input}
              value={business.email}
              onChange={e => handleBusiness("email", e.target.value)}
            />
          </div>
          <div style={styles.inputFull}>
            <textarea
              placeholder="Current Problems You Want To Solve..."
              style={styles.textarea}
              value={business.problems}
              onChange={e => handleBusiness("problems", e.target.value)}
            />
          </div>
          <div>
            <textarea
              placeholder="Additional Notes..."
              style={styles.textarea}
              value={business.notes}
              onChange={e => handleBusiness("notes", e.target.value)}
            />
          </div>
        </div>

        <hr style={styles.divider} />

        <button
          onClick={generateSummary}
          disabled={loading}
          style={styles.submitBtn(loading)}
          onMouseOver={e => { if (!loading) e.currentTarget.style.opacity = "0.85"; }}
          onMouseOut={e => { e.currentTarget.style.opacity = "1"; }}
        >
          {loading ? "Submitting..." : "Submit Software Request"}
        </button>

        {summary && (
          <div style={styles.summaryCard}>
            <div style={styles.summaryHeader}>Software Request Summary</div>

            <p style={styles.summaryBusinessName}>{summary.business.businessName || "—"}</p>
            <p style={styles.summaryContact}>
              {summary.business.contactName || "—"} &nbsp;·&nbsp; {summary.business.email || "—"} &nbsp;·&nbsp; {summary.business.phone || "—"}
            </p>

            <div style={styles.summarySection}>
              <div style={styles.summarySectionTitle}>Selected Features ({summary.selected.length})</div>
              {summary.selected.length === 0 && (
                <p style={{ fontSize: "13px", color: "rgba(255,255,255,0.4)", margin: 0 }}>No features selected.</p>
              )}
              {summary.selected.map(f => (
                <div key={f.key} style={styles.selectedFeatureRow}>
                  <span style={styles.selectedFeatureName}>{f.title}</span>
                  <span style={styles.featureTag(summary.selections[f.key])}>
                    {platformLabel(summary.selections[f.key])}
                  </span>
                </div>
              ))}
            </div>

            {summary.addons.length > 0 && (
              <div style={styles.summarySection}>
                <div style={styles.summarySectionTitle}>Additional Requirements</div>
                <div style={styles.addonTagRow}>
                  {summary.addons.map(a => (
                    <span key={a} style={styles.addonTag}>{a}</span>
                  ))}
                </div>
              </div>
            )}

            <div style={styles.summaryRow}>
              <span style={styles.summaryKey}>Preferred App Type</span>
              <span style={styles.summaryVal}>
                {summary.appType === "web" ? "Web App Only" : summary.appType === "mobile" ? "Mobile App Only" : summary.appType === "both" ? "Both Web + Mobile" : "—"}
              </span>
            </div>

            {summary.business.problems && (
              <div style={{ ...styles.summaryRow, flexDirection: "column", alignItems: "flex-start" }}>
                <span style={styles.summaryKey}>Problems to Solve</span>
                <span style={{ ...styles.summaryVal, textAlign: "left", marginTop: "6px", color: "rgba(255,255,255,0.7)", lineHeight: "1.5" }}>{summary.business.problems}</span>
              </div>
            )}

            {summary.business.notes && (
              <div style={{ ...styles.summaryRow, flexDirection: "column", alignItems: "flex-start", borderBottom: "none" }}>
                <span style={styles.summaryKey}>Additional Notes</span>
                <span style={{ ...styles.summaryVal, textAlign: "left", marginTop: "6px", color: "rgba(255,255,255,0.7)", lineHeight: "1.5" }}>{summary.business.notes}</span>
              </div>
            )}

            <div style={styles.thankYouBox}>
              <p style={styles.thankYouText}>
                ✓ Thank you! We will review your requirements and contact you with a proposal and pricing.
              </p>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}